/**
 * Bootstrap 5's colours, the lib's one palette on the TypeScript side. Styles take them from
 * Bootstrap itself (`var(--bs-*)`); this list is for code that needs the value: canvas drawing,
 * charts, colour fields, fallbacks. The PHP side is Lib\Support\BootstrapColors.
 */
export const BOOTSTRAP_COLORS = {
	blue: '#0d6efd',
	indigo: '#6610f2',
	purple: '#6f42c1',
	pink: '#d63384',
	red: '#dc3545',
	orange: '#fd7e14',
	yellow: '#ffc107',
	green: '#198754',
	teal: '#20c997',
	cyan: '#0dcaf0',
	white: '#ffffff',
	black: '#000000',
	gray100: '#f8f9fa',
	gray300: '#dee2e6',
	gray500: '#adb5bd',
	gray600: '#6c757d',
	gray700: '#495057',
	gray800: '#343a40',
	gray900: '#212529',
} as const;

const c = BOOTSTRAP_COLORS;

/** Bootstrap's theme colours, its $theme-colors map. */
export const THEME_COLORS = {
	primary: c.blue,
	secondary: c.gray600,
	success: c.green,
	info: c.cyan,
	warning: c.yellow,
	danger: c.red,
	light: c.gray100,
	dark: c.gray900,
} as const;

export type ThemeColor = keyof typeof THEME_COLORS;

/** The series colours of every chart, in the order a chart uses them. */
export const CHART_PALETTE: readonly string[] = [c.blue, c.green, c.yellow, c.red, c.purple, c.teal, c.orange, c.cyan];

/** The colour of the n-th series, the palette repeated. */
export function chartColor(index: number): string {
	return CHART_PALETTE[index % CHART_PALETTE.length];
}
